<template lang="pug">
  .home
    section.section-1
      slider
      .container
        .search-wrap
          .search-box
            h2 {{ gettext('Hiring and working abroad has never been easier!') }}
            .tabs
              ul
                li(:class="{ 'is-active': employer}"): a(@click="employer = true") {{ gettext('I am an employer') }}
                li(:class="{ 'is-active': !employer}"): a(@click="employer = false") {{ gettext('I am a job seeker') }}
            .search
              .control-wrap
                .control.is-expanded(:class="{'width-50': employer}")
                  input(
                  type="text"
                  v-model="query"
                  @keyup.enter="search()"
                  :placeholder="employer ? gettext('Enter the profession, for example: trainee') : gettext('Enter a job name, for example: truck driver')")
                .control.contry-select(v-if="!employer")
                  ajax-multiselect(
                  v-model="country"
                  :labelText="gettext('Choose the country')"
                  :itemName ="'name'"
                  :returnItem="'id'"
                  :action="{method: 'receiveCountries', params:{lang: getLanguage, filters: ['for_jobseeker_profile'] }}",
                  :multiple="false"
                  :searchable="true"
                  :hideSelected="true"
                  :closeOnSelect="true"
                  )
                .control.search-btn
                  button.button.search-button(@click="search()")
                    i.mdi.mdi-magnify
            .find-btn-wrap
              router-link.main-btn.col-white.bg-red(v-if="!query" :to="{name: 'FindCategories', params: {lang: getLanguage}, query: {search: 'workers'}}")
                img(src="/webapp/images/home/employer-search.png")
                span {{ gettext('Find worker') }}
              router-link.main-btn.col-white.bg-red(v-else :to="{name: 'Workers', params: {lang: getLanguage}, query: {q: query}}")
                img(src="/webapp/images/home/employer-search.png")
                span {{ gettext('Find worker') }}
              router-link.main-btn.col-white.bg-black(:to="{name: 'FindJob', params: {lang: getLanguage}, query: computedQuery}")
                img(src="/webapp/images/home/job-seaker-search.png")
                span {{ gettext('Find job') }}
    section.gray-bg.partners-bg
      .container.partners-section
        .headline
          | {{ gettext('We are connecting employers and job-seekers local and international.') }}
    workers
    jobs
    section.section-6.contact-us
      .blocks-wrap
        .section-6-wrap
          .contact-form.container
            .left
              span.note {{ gettext('Need a new employee or a trainee?') }}
              span.big {{ gettext('Call us or fill up the form') }}
              span {{ gettext('Head office') + ' ' }}
                a(href="tel:+45 71 74 75 04") +45 71 74 75 04
              span {{ gettext('mo - fr') }}: 08.00 - 17.00
              span.mail {{ gettext('mail') + ': ' }}
                a(href="mailto:info@bixter.com ") info@bixter.com
              br
              span {{ gettext('We\'ll contact you during 24 hours') }}
            .right.gray-bg(v-if="!thankModal")
              .tile.field(v-if="(!$auth.check())")
                .field-body
                  input.input(
                  :placeholder="gettext('Name')"
                  v-model="form.name"
                  )
              .tile.field(v-if="(!$auth.check())")
                .field-body
                  v-phone-input(
                  name="phone"
                  v-model="form.phone"
                  @blur="validateData('phone')"
                  :class="{'is-danger': $v.form.phone.$error, 'is-empty': !form.phone}"
                  @onInput="form.phone = $event.number"
                  ref="phoneInput"
                  :phone="form.phone"
                  )
              .tile.field(v-if="(!$auth.check())")
                .field-body
                  input.input(
                  :placeholder="gettext('Email')"
                  v-model="form.email"
                  @blur="validateData('email')"
                  :class="{'is-danger': $v.form.email.$error, 'is-empty': !form.email}"
                  )
              .tile.field
                .field-body
                  textarea.textarea(
                  rows="7"
                  :placeholder="gettext('Tell us who are you looking for and we will contact you as soon as possible')"
                  v-tooltip="{content: errors.required, show: tooltip.text}"
                  :class="{'is-danger': $v.form.text.$error, 'is-empty': !form.text}"
                  @blur="validateData('text')"
                  v-model="form.text")
              .tile.field(v-if="(!$auth.check())")
                .field-body
                  input#custom-checkbox.is-checkradio.custom-checkbox(
                  type="checkbox"
                  v-model="form.agree"
                  )
                  label.checkbox(for="custom-checkbox")
                    | {{ gettext('I agree to the') }} &nbsp;
                    router-link(:to="`/${getLanguage}/terms-and-conditions`" target='_blank') {{ gettext('terms and conditions') }}
                label.label.is-hidden-mobile
              .tile.btns
                .main-btn.col-white.bg-red(
                @click="send()"
                :disabled="$v.$invalid || (!$auth.check() && !form.agree) || loading"
                ) {{ gettext('Send') }}
    testimonials
    <!--section.section-6.gray-bg-->
      <!--.block-wrap-->
        <!--.section-6-wrap-->
          <!--.headline-->
            <!--span {{ gettext('Countries we are working with') }}-->
          <!--.countries-->
            <!--router-link.country(:to="`/${getLanguage}/countries/country/denmark`")-->
              <!--.img(style="background-image: url(/webapp/images/countries/denmark.png);")-->
              <!--.filter-->
              <!--span {{ gettext('Denmark') }}-->
            <!--router-link.country(:to="`/${getLanguage}/countries/country/germany`")-->
              <!--.img(style="background-image: url(/webapp/images/countries/germany.png);")-->
              <!--.filter-->
              <!--span {{ gettext('Germany') }}-->
            <!--router-link.country(:to="`/${getLanguage}/countries/country/norway`")-->
              <!--.img(style="background-image: url(/webapp/images/countries/1.png);")-->
              <!--.filter-->
              <!--span {{ gettext('Norway') }}-->
            <!--router-link.country(:to="`/${getLanguage}/countries/country/estonia`")-->
              <!--.img(style="background-image: url(/webapp/images/countries/estonia-min.png);")-->
              <!--.filter-->
              <!--span {{ gettext('Estonia') }}-->
          <!--router-link.btn(:to="`/${getLanguage}/countries`") {{ gettext('More countries') }}-->
    banner
    video-modal(
    v-if="showVideoModal"
    @close="showVideoModal = !showVideoModal"
    :isYoutube="false"
    :iframeSrc="link"
    videoType="video/mp4"
    )
    v-modal(:show.sync="thankModal" :clickAway="true")
      section.modal-card-body.requestMOdal
        h3.thank-you {{ gettext('Thank you, we will contact you as soon as possible!') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext } from './../../services/TranslateHandler'
import AjaxDropdown from '@/components/ajax-dropdown'
import AjaxMultiselect from '@/components/ajax-multiselect'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import VideoModal from '@/components/video-modal'
import LocationDropdown from '@/components/location-dropdown'
import mixin from '@/mixins'
import testimonials from './parts/testimonials'
import workers from './parts/workers'
import jobs from './parts/jobs'
import slider from './parts/slider'
import VPhoneInput from '@/components/v-phone-input'
import { required, requiredIf, email } from 'vuelidate/lib/validators'
import VTooltip from 'v-tooltip'
import VModal from '@/components/modal'
import banner from './parts/banner'
const _ = require('lodash')

const inactive = require('@/constants.json')
const CONSTANTS = require('@/constants.json')

export default {
  name: 'Home',
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo})
  },
  components: {
    swiper,
    swiperSlide,
    VideoModal,
    LocationDropdown,
    AjaxDropdown,
    AjaxMultiselect,
    testimonials,
    workers,
    jobs,
    VModal,
    VTooltip,
    VPhoneInput,
    slider,
    banner
  },
  methods: {
    ...mapActions([
      'sendCvsContactsNonAuth',
      'sendCvsContactsAuth'
    ]),
    gettext: gettext,
    search () {
      let query = {}
      if (this.query) query.q = this.query
      if (this.country) query.c = this.country
      if (this.employer) this.$router.push({name: 'Workers', params: {lang: this.getLanguage}, query: query})
      else this.$router.push({name: 'FindJob', params: {lang: this.getLanguage}, query: query})
    },
    validateData (item) {
      if (item) {
        this.$v.form[item].$touch()
        if (this.$v.form[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.form
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    clearRequestForm () {
      this.$v.$reset()
      this.form = {
        name: '',
        email: '',
        phone: '',
        text: '',
        agree: false
      }
    },
    reset () {
      this.$v.$reset()
    },
    clear () {
      this.form = {
        name: '',
        email: '',
        phone: '',
        text: '',
        agree: false
      }
    },
    send () {
      this.loading = true
      this.validateData()
      if (this.$auth.check()) {
        this.sendCvsContactsAuth({
          lang: this.getLanguage,
          form_data: {
            text: this.form.text
          }
        }).then(res => {
          if (res.success) {
            this.sent = true
            this.loading = false
            this.thankModal = true
            this.clearRequestForm()
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      } else {
        this.sendCvsContactsNonAuth({
          lang: this.getLanguage,
          form_data: {
            name: this.form.name,
            email: this.form.email,
            phoneNumber: this.form.phone,
            text: this.form.text,
            agree: this.form.agree
          }
        }).then(res => {
          if (res.success) {
            this.sent = true
            this.loading = false
            this.thankModal = true
            this.clearRequestForm()
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getUser'
    ]),
    errors () {
      return {
        required: gettext('This field is required')
      }
    },
    computedQuery () {
      if (this.query || this.country) return {q: this.query, c: this.country}
      return {}
    },
    defaultMetaInfo () {
      return {
        title: 'Bixter',
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    },
    link () {
      let lang = this.getLanguage || 'en'
      return this.$store.state.promoVideos[lang].video_url
    }
  },
  data () {
    return {
      CONSTANTS: CONSTANTS,
      inactive: inactive,
      showVideoModal: false,
      employer: true,
      country: '',
      query: '',
      form: {
        text: '',
        name: '',
        phone: '',
        email: '',
        agree: false
      },
      thankModal: false,
      loading: false,
      tooltip: {},
      sent: false,
      swiperOption: {
        slidesPerView: 5,
        loop: true,
        loopFillGroupWithBlank: true,
        breakpoints: {
          400: {
            slidesPerView: 1
          },
          550: {
            slidesPerView: 2
          },
          768: {
            slidesPerView: 3
          },
          1024: {
            slidesPerView: 4
          }
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        }
      }
    }
  },
  validations () {
    if (this.$auth.check()) {
      return {
        form: {
          text: {required}
        }
      }
    } else {
      return {
        form: {
          text: {required},
          email: {
            email,
            required: requiredIf(() => {
              return !this.form.phone
            })
          },
          phone: {
            required: requiredIf(() => {
              return !this.form.email
            }),
            isUnique () {
              if (this.form.phone === undefined) return true
              return new Promise((resolve) => {
                this.$nextTick(() => {
                  resolve(this.$refs.phoneInput.isValidInp)
                })
              })
            }
          },
          name: {}
        }
      }
    }
  }
}
</script>

<style lang="scss" src="./styles.scss"></style>



// WEBPACK FOOTER //
// src/pages/home/index.vue